export enum SortBy {
  CreatedAt = "createdAt",
  MemberName = "member-name",
}
